import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-10888d40"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "subpage" }

import { ITabMenuProps } from '@/common/components/snedson-material-components/tab-menu/tab-menu.types';
import TabMenu from '@/common/components/snedson-material-components/tab-menu/tab-menu.vue';
import router from '@/router';
import AllStudentsSubpage from './Subpages/AllStudentsSubpage/AllStudentsSubpage.vue';
import AbsentStudentsSubpage from './Subpages/AbsentStudentsSubpage/AbsentStudentsSubpage.vue';
import HomeworkSubpage from './Subpages/HomeworkSubpage/HomeworkSubpage.vue';
import ModifiedScheduleSubpage from './Subpages/ModifiedScheduleSubpage/ModifiedScheduleSubpage.vue';
import UsualScheduleSubpage from './Subpages/UsualScheduleSubpage/UsualScheduleSubpage.vue';
import { reactive } from 'vue';
import { ClassSubpage } from './ClassPage.types';
import { HandleAnimation } from '@/services/animation-service';
import { animationState } from '@/services/animation-service/animation-state.ts';


export default /*#__PURE__*/_defineComponent({
  __name: 'ClassPage',
  setup(__props) {

const state = reactive<ITabMenuProps>({
    tabs: [
        {
            id: ClassSubpage.AllStudents,
            title: 'Все учащиеся',
        },
        {
            id: ClassSubpage.AbsentStudents,
            title: 'Сегодня отсутствуют',
        },
        {
            id: ClassSubpage.Homework,
            title: 'Домашние задания',
        },
        {
            id: ClassSubpage.ModifiedSchedule,
            title: 'Расписание - измененное',
        },
        {
            id: ClassSubpage.UsualSchedule,
            title: 'Расписание - стандартное',
        },
    ],
    selectedTabItemId: ClassSubpage.AllStudents,
});

const selectTab = (tabId: ClassSubpage) => {
    animationState.flow = HandleAnimation('horizontal', state.selectedTabItemId, tabId);
    state.selectedTabItemId = tabId;

    switch (tabId) {
        case ClassSubpage.AllStudents: {
            router.push({ name: 'sn.teacher.class.allStudents' });
            break;
        }
        case ClassSubpage.AbsentStudents: {
            router.push({ name: 'sn.teacher.class.absentStudents' });
            break;
        }
        case ClassSubpage.Homework: {
            router.push({ name: 'sn.teacher.class.homeworks' });
            break;
        }
        case ClassSubpage.ModifiedSchedule: {
            router.push({ name: 'sn.teacher.class.modifiedSchedule' });
            break;
        }
        case ClassSubpage.UsualSchedule: {
            router.push({ name: 'sn.teacher.class.usualSchedule' });
            break;
        }
    }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(TabMenu, {
      props: state,
      onChange: selectTab
    }, null, 8, ["props"]),
    _createElementVNode("div", _hoisted_1, [
      (state.selectedTabItemId === _unref(ClassSubpage).AllStudents)
        ? (_openBlock(), _createBlock(AllStudentsSubpage, { key: 0 }))
        : _createCommentVNode("", true),
      (state.selectedTabItemId === _unref(ClassSubpage).AbsentStudents)
        ? (_openBlock(), _createBlock(AbsentStudentsSubpage, { key: 1 }))
        : _createCommentVNode("", true),
      (state.selectedTabItemId === _unref(ClassSubpage).Homework)
        ? (_openBlock(), _createBlock(HomeworkSubpage, { key: 2 }))
        : _createCommentVNode("", true),
      (state.selectedTabItemId === _unref(ClassSubpage).ModifiedSchedule)
        ? (_openBlock(), _createBlock(ModifiedScheduleSubpage, { key: 3 }))
        : _createCommentVNode("", true),
      (state.selectedTabItemId === _unref(ClassSubpage).UsualSchedule)
        ? (_openBlock(), _createBlock(UsualScheduleSubpage, { key: 4 }))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})